import { datafluxRum } from '@cloudcare/browser-rum';

export const maskEmail = (email: string): string => {
  const [username, domain] = email.split('@');
  let maskedUsername = username;

  if (username.length > 4) {
    const start = username.slice(0, 2);
    const end = username.slice(-2);
    maskedUsername = `${start}***${end}`;
  } else if (username.length > 1) {
    maskedUsername = `${username[0]}***${username[username.length - 1]}`;
  } else {
    maskedUsername = '***';
  }

  return `${maskedUsername}@${domain}`;
};

export const downloadAndProgress = (
  url: string,
  filename: string,
  onProgress?: (progress: number) => void
) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.responseType = 'blob';

  // 监听下载进度
  xhr.onprogress = (event) => {
    if (event.lengthComputable && onProgress) {
      const percentComplete = Math.round((event.loaded / event.total) * 100);
      onProgress(percentComplete);
    }
  };

  xhr.onload = () => {
    if (xhr?.status === 200) {
      const blob = xhr.response;
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    }
  };

  xhr.send();
};

export const getAhaSourceFromUrlSearch = () => {
  try {
    const search = window.location.search;
    return new URLSearchParams(search)?.get('aha_source');
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const isMobile = () => {
  if (window.navigator) {
    const ua = navigator.userAgent.toLowerCase();
    return /mobile|android|iphone|ipod|phone|ipad/i.test(ua);
  } else {
    return false;
  }
};

/**
 * 格式化数字：添加千分位分隔符，大数使用k/M/B表示
 * @param num 要格式化的数字
 * @returns 格式化后的字符串
 */
export const formatNumber = (num: number | string) => {
  if (num === undefined || num === null) return "N/A";
  const numValue = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(numValue) || numValue < 0) return "N/A";

  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 0
  });
  
  const absNum = Math.abs(numValue);
  const sign = numValue < 0 ? '-' : '';

  if (absNum >= 1000000000) {
    return `${sign}${formatter.format(absNum / 1000000000)}B`;
  } else if (absNum >= 1000000) {
    return `${sign}${formatter.format(absNum / 1000000)}M`;
  } else if (absNum >= 1000) {
    return `${sign}${formatter.format(absNum / 1000)}K`;
  } else {
    return formatter.format(numValue);
  }
};

/**
 * 格式化货币：保留两位小数，添加美元符号
 * @param num 要格式化的数字
 * @returns 格式化后的字符串
 */
export const formatCurrency = (num: number | string, decimal = 2) => {
  if (num === undefined || num === null) return "N/A";
  const numValue = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(numValue) || numValue < 0) return "N/A";

  return `$${numValue?.toLocaleString('en-US', {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  })}`;
};

export const formatRatio = (num: number | string) => {
  if (num === undefined || num === null) return "N/A";
  const numValue = typeof num === "string" ? parseFloat(num) : num;
  if (isNaN(numValue) || numValue < 0) return "N/A";

  return `${(Number(num) * 100).toFixed(2)}%`;
};

export const localStorageSaveUtmMediumAndSource = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const utmMedium = searchParams.get('utm_medium');
  const utmSource = searchParams.get('utm_source');
  const firstUtmSource = searchParams.get('first_utm_source');
  const firstUtmMedium = searchParams.get('first_utm_medium');
  if (utmMedium) {
    window.localStorage.setItem('utm_medium', utmMedium);
  }
  if (utmSource) {
    window.localStorage.setItem('utm_source', utmSource);
  }
  if (firstUtmSource) {
    window.localStorage.setItem('first_utm_source', firstUtmSource);
  }
  if (firstUtmMedium) {
    window.localStorage.setItem('first_utm_medium', firstUtmMedium);
  }
};

export const getIsYearPlanFromUrl = () => {
  // 获取 ?isYear=xxx 和 ?a=xxx&isYear=xxx 的情况
  try {
    const search = window.location.search;
    return new URLSearchParams(search)?.get('isYear');
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const getIsSubscriptionFromUrl = () => {
  // 获取 ?isSubscription=xxx 和 ?a=xxx&isSubscription=xxx 的情况
  try {
    const search = window.location.search;
    return new URLSearchParams(search)?.get('isSubscription');
  } catch (error) {
    console.error(error);
    return '';
  }
};
